// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vmNR","content":"styles_content__dxSgW","row":"styles_row__2-WRx","footer":"styles_footer__3LBg2","phraseLength":"styles_phraseLength__2uJ1_"};